import { buildAppCanonicalUrl, isIndexableAppPath } from "./web-indexing";

export const APP_WEB_CANONICAL_URL = buildAppCanonicalUrl("/");

export type WebPageMetadataInput = {
  pathname: string;
  routeMetadata: {
    title: string;
    description: string;
  };
  entryMetadata: {
    title: string;
    description: string;
  };
  origin?: string;
};

export type ResolvedWebPageMetadata = {
  title: string;
  description: string;
  canonicalUrl: string | null;
  robots: "index, follow" | "noindex, nofollow";
  indexable: boolean;
};

export function isIndexableAppEntryPath(pathname: string) {
  return pathname === "/" || pathname === "/login";
}

export function resolveWebPageMetadata({
  pathname,
  routeMetadata,
  entryMetadata,
  origin,
}: WebPageMetadataInput): ResolvedWebPageMetadata {
  const indexable = isIndexableAppPath(pathname);
  const metadata = isIndexableAppEntryPath(pathname)
    ? entryMetadata
    : routeMetadata;

  return {
    ...metadata,
    canonicalUrl: indexable ? buildAppCanonicalUrl(pathname, origin) : null,
    robots: indexable ? "index, follow" : "noindex, nofollow",
    indexable,
  };
}
